import React from 'react';
import WorldMap from 'react-svg-worldmap';
import PropTypes from 'prop-types';
import {polyfillCountryFlagEmojis} from 'country-flag-emoji-polyfill';

export default function CountriesMap(props) {
    polyfillCountryFlagEmojis();

    const data = [];
    props.data.forEach((country, key) => {
        data.push({country: key.toLowerCase(), value: true, label: country});
    });

    const width = props.rightPanel ? '640px' : '1200px';
    const gridTemplateColumns = '1fr' + ' 1fr'.repeat(props.rightPanel ? 2 : 4);

    return <div className='CountriesMapContainer' style={{margin: '0 auto', width}}>
        <WorldMap
            color="#EB0017"
            size={props.rightPanel? 'xl' : 'xxl'}
            data={data}
            strokeOpacity={1}
            borderColor='#46535E'
            tooltipTextFunction={(country) => country.countryName}
        />

        <div className='CountriesMapLegend' style={{display: 'grid', gap: '5px 20px', gridTemplateColumns}}>
            {data.map((country) => <div key={country.country} className='CountriesMapLegendItem'>
                {country.country.toUpperCase().replace(/./g, (char) => String.fromCodePoint(127397 + char.charCodeAt()))} {country.label}
            </div>)}
        </div>
    </div>;
}

CountriesMap.propTypes = {
    data: PropTypes.object.isRequired,
    rightPanel: PropTypes.bool,
};
